import React from 'react';
import moment from 'moment';
import { processType } from 'constants/process-type';
import { ShowIf } from 'components/utils';
import { Text, TextMessage } from 'components/tt-forms/common';
import { ContainerFileDinhKem } from 'components/upload';
import { isArray, isEmpty } from 'lodash';

class TrinhLanhDaoView extends React.Component {

  render() {
    let taiLieuDinhKem = this.props.listTaiLieuVanThu;
    if (isArray(this.props.listTaiLieuVanThuChuyenDonBoSungHoSo) && !isEmpty(this.props.listTaiLieuVanThuChuyenDonBoSungHoSo)) {
      this.props.listTaiLieuVanThuChuyenDonBoSungHoSo.forEach(item => {
        taiLieuDinhKem.push(item);
      });
    }
    return (
      <div className="items-form mb5">       
        <div className="row pr10 pl10">
          <Text
            className="col-input"
            label="Hướng xử lý:"
            value={this.props.thongTinXuLyGiaiQuyet.quyTrinhXuLy ?
              this.props.thongTinXuLyGiaiQuyet.quyTrinhXuLy : ''} />
          <ShowIf condition={this.props.thongTinXuLyGiaiQuyet.nextState.type == processType.xuLyDon.processing.trinhLanhDao}>
            <Text
              red={true}
              className="col-input"
              label="Hạn xử lý:"
              value={this.props.thongTinXuLyGiaiQuyet.thoiHanXuLy ?
                moment(this.props.thongTinXuLyGiaiQuyet.thoiHanXuLy).format('DD/MM/YYYY') : ''} />
          </ShowIf>
          <ShowIf condition={this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinh != null}>
            <Text
              className="col-input"
              label="Lãnh đạo:"
              value={this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinh ? this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinh.ten : ''} />
          </ShowIf>
        </div>
        <div className="row pr10 pl10">
          <TextMessage
            className="col-12"
            value={this.props.thongTinXuLyGiaiQuyet.yKienXuLy || ''}
            label='Nội dung:' />
        </div>
        <div className="container-filedinhkem">
          <ContainerFileDinhKem label="Danh sách văn bản xử lý" disableAttachFile bindValidator={this} dataShow={taiLieuDinhKem} />
        </div>
      </div>
    )
  }
}

export default TrinhLanhDaoView;


// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/xu-ly-don/form-xu-ly/chuyen-vien-nhap-lieu/TrinhLanhDaoView.jsx